import React from 'react';
import { ReactImageGalleryItemWithSpinnerData } from 'src/components/ApartmentPageV2/ApartmentGallery/types';
import { useIsMobile } from 'src/hooks';
import { SvgPlay } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgPlay';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';

export const ApartmentDescriptionTour: React.FC<{tour: ReactImageGalleryItemWithSpinnerData, useCover?: boolean}> = ({ tour, useCover }) => {
  const theme: Theme = useTheme();
  const { isMobileScreen } = useIsMobile();
  const onClick = (_tour: ReactImageGalleryItemWithSpinnerData) => {
    window.open(_tour.original, '_blank');
  };

  return (
    <React.Fragment key={tour.id}>
      {isMobileScreen && (
        <>
          {useCover && (
          <Box
            className="gallery-playcanvas-v2 mac-background"
            onClick={() => onClick(tour)}
          >
            <SvgPlay playBtnColor={theme.palette.background.default} />
          </Box>
          )}
          {!useCover && (
          <iframe
            key={tour.original}
            allowFullScreen
            title="sometitle"
            src={tour.original}
            className="gallery-playcanvas-v2"
          />
          )}
        </>
      )}
      {!isMobileScreen && (
        <iframe
          key={tour.original}
          allowFullScreen
          title="sometitle"
          src={tour.original}
          className="gallery-playcanvas-v2"
        />
      ) }
    </React.Fragment>
  );
};
